export default "__VITE_ASSET__DtXbZUjG__"